(function () {
  // Google listing bundle products -> main product with offer preselected.
  // Source: marine-vitality-google-listing.xlsx
  var redirects = {
    // Mussel Powder - 150g
    "/products/buy-2-marine-vitality-mussel-powder-150g": "/products/marine-vitality-mussel-powder-150g-dog?offer=buy-2&subs=30-days",
    "/products/buy-3-marine-vitality-mussel-powder-150g": "/products/marine-vitality-mussel-powder-150g-dog?offer=buy-3&subs=30-days",

    // Mussel Powder For Dogs - 150g
    "/products/buy-2-marine-vitality-mussel-powder-for-dogs-150g": "/products/marine-vitality-mussel-powder-150g-dog?offer=buy-2&subs=30-days",
    "/products/buy-3-marine-vitality-mussel-powder-for-dogs-150g": "/products/marine-vitality-mussel-powder-150g-dog?offer=buy-3&subs=30-days",

    // Mussel Powder For Cats - 150g
    "/products/buy-2-marine-vitality-mussel-powder-for-cats-150g": "/products/marine-vitality-mussel-powder-150g-cat?offer=buy-2&subs=30-days",
    "/products/buy-3-marine-vitality-mussel-powder-for-cats-150g": "/products/marine-vitality-mussel-powder-150g-cat?offer=buy-3&subs=30-days",

    // Mussel Powder For Horses & Ponies - 150g
    "/products/buy-2-marine-vitality-mussel-powder-for-horses-ponies-150g": "/products/mussel-powder-horse?offer=buy-2&subs=30-days",
    "/products/buy-3-marine-vitality-mussel-powder-for-horses-ponies-150g": "/products/mussel-powder-horse?offer=buy-3&subs=30-days"
  };

  // Normalize path: lowercase, strip trailing slash and any /collections/x prefix
  var path = window.location.pathname
    .toLowerCase()
    .replace(/\/+$/, "")
    .replace(/^\/collections\/[^/]+(?=\/products\/)/, "");
  var target = redirects[path];
  if (!target) return;

  // Keep incoming params (gclid, utm_*, etc.); target's offer/subs win.
  // Drop "variant" - it belongs to the bundle product, not the destination.
  var parts = target.split("?");
  var params = new URLSearchParams(window.location.search);
  params.delete("variant");
  new URLSearchParams(parts[1] || "").forEach(function (value, key) {
    params.set(key, value);
  });

  var qs = params.toString();
  window.location.replace(parts[0] + (qs ? "?" + qs : "") + window.location.hash);
})();
